import { useEffect, useRef, useState } from "react";
import { Pause, Play, RotateCcw } from "lucide-react";
import { EMPTY_TEXT, ERROR_TEXT } from "@/lib/api";

const fmt = (s) => (Number.isFinite(s) ? `${Math.floor(s / 60)}:${String(Math.floor(s % 60)).padStart(2, "0")}` : "--:--");

export const AudioPlayer = ({ src, title }) => {
  const ref = useRef(null);
  const [playing, setPlaying] = useState(false);
  const [time, setTime] = useState(0);
  const [dur, setDur] = useState(NaN);
  const [error, setError] = useState(false);

  useEffect(() => () => ref.current?.pause(), []);

  if (!src) {
    return (
      <div className="audio-card is-empty" data-testid="practice-audio-empty">
        <button className="audio-play" disabled aria-label="Audio no disponible"><Play /></button>
        <p>{EMPTY_TEXT}</p>
      </div>
    );
  }

  const toggle = () => (ref.current.paused ? ref.current.play() : ref.current.pause());
  return (
    <div className="audio-card" data-testid="practice-audio-player">
      <audio ref={ref} src={src} preload="metadata"
        onPlay={() => setPlaying(true)} onPause={() => setPlaying(false)} onEnded={() => setPlaying(false)}
        onTimeUpdate={(e) => setTime(e.target.currentTime)} onLoadedMetadata={(e) => setDur(e.target.duration)}
        onError={() => setError(true)} />
      <button className="audio-play" onClick={toggle} disabled={error} data-testid="practice-audio-toggle"
        aria-label={playing ? `Pausar ${title}` : `Reproducir ${title}`}>
        {playing ? <Pause /> : <Play />}
      </button>
      <div className="audio-track">
        <input type="range" min={0} max={Number.isFinite(dur) ? dur : 0} step={1} value={time}
          onChange={(e) => { ref.current.currentTime = Number(e.target.value); }}
          aria-label="Posición del audio" data-testid="practice-audio-seek"
          style={{ "--pct": `${Number.isFinite(dur) && dur > 0 ? (time / dur) * 100 : 0}%` }} />
        <div className="audio-times"><span>{fmt(time)}</span><span>{fmt(dur)}</span></div>
      </div>
      <button className="icon-btn" onClick={() => { ref.current.currentTime = 0; }} aria-label="Volver al principio" data-testid="practice-audio-restart"><RotateCcw /></button>
      {error && <p className="text-danger" style={{ gridColumn: "1 / -1", margin: 0, fontSize: 14 }}>{ERROR_TEXT}</p>}
    </div>
  );
};
